import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { BodyText, DisplayText, Icon, theme, useResponsive } from '@sg/garnish';

import { ICON_SIZE, ICON_SIZE_SMALLER } from '../utils';

export const OrderPlaybackOrderDetails = (
  props: OrderPlaybackOrderDetailsProps,
) => {
  const { count } = props;

  const { minWidth, currentHeight } = useResponsive();
  const withSmallerFont = minWidth.isSM && currentHeight.isSM;
  const fontSize: '16' | '24' = withSmallerFont ? '16' : '24';
  const fontSizeItems: '14' | '16' = withSmallerFont ? '14' : '16';

  return (
    <View style={styles.orderDetails}>
      <View style={styles.row}>
        <View style={withSmallerFont ? styles.iconSmaller : styles.icon}>
          <Icon
            name="IconOrderPlaybackItems"
            color={theme.colors.KALE}
            width={withSmallerFont ? ICON_SIZE_SMALLER : ICON_SIZE}
            height={withSmallerFont ? ICON_SIZE_SMALLER : ICON_SIZE}
          />
        </View>

        <DisplayText style={styles.text} bold sizeMatch={[fontSize]}>
          <FormattedMessage {...messages.orderDetails} />
        </DisplayText>
      </View>

      <BodyText sizeMatch={[fontSizeItems]}>
        <FormattedMessage {...messages.items} values={{ count }} />
      </BodyText>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  orderDetails: {
    defaultMessage: 'Order details',
    description: 'Bag | Order playback | Order details',
  },
  items: {
    defaultMessage: '{count} Items',
    description: 'Bag | Order playback | Items',
  },
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.KALE,
  },
  icon: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    marginBottom: theme.spacing['1'],
  },
  iconSmaller: {
    width: ICON_SIZE_SMALLER,
    height: ICON_SIZE_SMALLER,
    marginBottom: theme.spacing['1'],
  },
  row: {
    flexDirection: 'row',
    gap: theme.spacing['3'],
  },
  orderDetails: {
    flexDirection: 'row',
    gap: theme.spacing['3'],
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderPlaybackOrderDetailsProps = {
  count: number;
};
